import finance from '../en/goods'

const cnGoods = {}

for (const cn in finance) {
  cnGoods[cn] = cn
}

export default cnGoods
